import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './AdminLayout.css';

const pageTitles = {
  '/dashboard': 'Dashboard',
  '/news': 'News Management',
  '/blogs': 'Blog Management',
  '/gallery': 'Gallery Management',
  '/clients': 'Clients Management',
  '/services': 'Services Management',
  '/reviews': 'Reviews Management',
  '/careers': 'Careers Management',
  '/cms': 'Website Content',
  '/cms/pages': 'Website Pages',
  '/cms/media': 'Media Library',
  '/cms/settings': 'Site Settings',
};

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const getPageTitle = () => {
    // Check for exact match first
    if (pageTitles[location.pathname]) {
      return pageTitles[location.pathname];
    }
    
    // Check for partial match (for routes like /news/add, /cms/pages/1)
    const segments = location.pathname.split('/').filter(Boolean);
    const sectionPath = '/' + segments.slice(0, 2).join('/');
    const basePath = '/' + (segments[0] || '');
    return pageTitles[sectionPath] || pageTitles[basePath] || 'Admin Panel';
  };

  return (
    <div className="admin-layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="admin-main">
        <Navbar 
          onMenuClick={() => setSidebarOpen(true)} 
          title={getPageTitle()}
        />
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
